/**
 * What the person sees on /entrar after the access policy ended their
 * session. Copy is deliberately plain and never uses the words the sign-in
 * form reads as "account banned" ("bloqueado", "blocked", "banned").
 *
 * The notice travels in a short-lived, non-httpOnly cookie
 * (`garagem_acesso_aviso`) set by the auth hook that revoked the session.
 * When a session was removed on another device (device cap) the hook that
 * revoked it cannot reach that device's browser, so a marker row keyed by
 * the hashed session token is stored instead and attached to the cookie on
 * that device's next `/get-session`.
 */

export const ACCESS_NOTICE_CODES = [
  "rede_nao_permitida",
  "fim_do_dia",
  "outro_aparelho",
] as const;

export type AccessNoticeCode = (typeof ACCESS_NOTICE_CODES)[number];

export const ACCESS_NOTICE_COOKIE = "garagem_acesso_aviso";
/** Cookie lifetime: long enough to survive the redirect, short enough to not linger. */
export const ACCESS_NOTICE_COOKIE_MAX_AGE_SECONDS = 10 * 60;
/** Marker rows for sessions revoked out-of-band (device cap). */
export const ACCESS_NOTICE_MARKER_TTL_MS = 24 * 60 * 60 * 1000;
export const ACCESS_NOTICE_MARKER_PREFIX = "access-policy-notice:";

/** Better Auth error code returned when sign-in is refused by the allowlist. */
export const ACCESS_POLICY_NETWORK_DENIED_CODE = "ACCESS_POLICY_NETWORK_DENIED";

export const ACCESS_NOTICE_COPY: Record<AccessNoticeCode, string> = {
  rede_nao_permitida:
    "Sua imobiliária só permite o acesso de certos lugares. Se você está no escritório e mesmo assim não entra, fale com o gestor.",
  fim_do_dia:
    "Sua imobiliária encerra o acesso no fim do dia. Entre de novo para continuar.",
  outro_aparelho:
    "Você entrou em outro aparelho. Entre de novo aqui se for você.",
};

export function isAccessNoticeCode(value: unknown): value is AccessNoticeCode {
  return (
    typeof value === "string" &&
    (ACCESS_NOTICE_CODES as readonly string[]).includes(value)
  );
}

export function accessNoticeMessage(code: AccessNoticeCode): string {
  return ACCESS_NOTICE_COPY[code];
}
